import { TableHeadItemRecurse } from '../../../../../components/TableHead';

export const tableHead: TableHeadItemRecurse[] = [
  { title: 'Operações', flex: 1.2 },
  { title: 'Ativo' },
  { title: 'Data da vencimento' },
  { title: 'Valor aplicado' },
  { title: 'Retorno' },
  { title: 'Valor marcação' },
];
